import ContentLoader from 'react-content-loader'

const ThreeDotLoader = () => {
  return (
    <ContentLoader
      viewBox="0 0 400 160"
      height={140}
      width={400}
      speed={1.9}
      backgroundColor="transparent"
    >
      <circle cx="150" cy="86" r="10" />
      <circle cx="194" cy="86" r="10" />
      <circle cx="238" cy="86" r="10" />
    </ContentLoader>
  )
}

export default ThreeDotLoader
